import styled from 'styled-components'
import {
  communicationContentWrapperCss,
  communicationImageWrapperCss,
  communicationRootCss,
  communicationSubtitleCss,
  communicationTitleCss,
  communicationTitleGroupCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const RatingScalePageStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div<{ $gap?: number }>`
    ${communicationContentWrapperCss}
    ${({ $gap }) => $gap !== undefined && `gap: ${$gap}px;`}
  `,

  TitleGroup: styled.div`
    ${communicationTitleGroupCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  Subtitle: styled.p`
    ${communicationSubtitleCss}
  `,

  ImageWrapper: styled.div`
    ${communicationImageWrapperCss}
  `,

  RatingBlock: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: auto;
  `,

  RatingButtons: styled.div`
    display: flex;
    gap: 8px;
  `,

  RatingButton: styled.button<{ $isSelected: boolean }>`
    flex: 1;
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#efeff6')};
    border: none;
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    color: ${({ $isSelected }) => ($isSelected ? COLORS.WHITE : '#17202a')};
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#efeff6')};
    }
  `,

  RatingLabels: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,

  RatingLabel: styled.span`
    font-family: 'Poppins', sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 1;
    color: #000;
    white-space: nowrap;
  `,

  ArrowLine: styled.div`
    flex: 1;
    height: 1px;
    background-color: #d1d5db;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-right: 5px solid #d1d5db;
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-left: 5px solid #d1d5db;
    }
  `,
}
